// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file files/v1/file.proto (package files.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file files/v1/file.proto.
 */
export const file_files_v1_file: GenFile = /*@__PURE__*/
  fileDesc("ChNmaWxlcy92MS9maWxlLnByb3RvEghmaWxlcy52MSLkBQoERmlsZRIVCgJpZBgBIAEoCzIJLnR5cGVzLklEEiIKD29yZ2FuaXphdGlvbl9pZBgCIAEoCzIJLnR5cGVzLklEEhMKC3N0b3JhZ2Vfa2V5GAMgASgJEhEKCWZpbGVfbmFtZRgEIAEoCRIRCglmaWxlX3NpemUYBSABKAMSEQoJbWltZV90eXBlGAYgASgJEhAKCGNoZWNrc3VtGAcgASgJEhIKCmNyZWF0b3JfaWQYCCABKAkSDgoGcHVibGljGAkgASgIEhMKC2VudGl0eV90eXBlGAogASgJEhwKCWVudGl0eV9pZBgLIAEoCzIJLnR5cGVzLklEEi4KCG1ldGFkYXRhGAwgAygLMhwuZmlsZXMudjEuRmlsZS5NZXRhZGF0YUVudHJ5Eg4KBnN0YXR1cxgNIAEoCRIuCgpleHBpcmVzX2F0GA4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgpjcmVhdGVkX2F0GA8gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GBAgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIRCglmaWxlX3R5cGUYESABKAkSEQoJcGFyZW50X2lkGBIgASgJEhIKCnVwbG9hZF91cmwYEyABKAkSMQoNdXBsb2FkX2V4cGlyeRgUIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKZGVsZXRlZF9hdBgVIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGgoSY3VycmVudF92ZXJzaW9uX2lkGBYgASgJEhUKDXZlcnNpb25fY291bnQYFyABKAUSGQoRdW5pcXVlX2NvbnRlbnRfaWQYGCABKAkaLwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBImsKFEZpbGVQZXJtaXNzaW9uQ2hhbmdlEg8KB3VzZXJfaWQYASABKAkSEgoKcGVybWlzc2lvbhgCIAEoCRIuCgZhY3Rpb24YAyABKA4yHi5maWxlcy52MS5GaWxlUGVybWlzc2lvbkFjdGlvbiLyAgoRQ3JlYXRlRmlsZVJlcXVlc3QSEQoJZmlsZV9uYW1lGAEgASgJEhEKCWZpbGVfc2l6ZRgCIAEoAxIRCgltaW1lX3R5cGUYAyABKAkSEwoLZW50aXR5X3R5cGUYBCABKAkSHAoJZW50aXR5X2lkGAUgASgLMgkudHlwZXMuSUQSOwoIbWV0YWRhdGEYBiADKAsyKS5maWxlcy52MS5DcmVhdGVGaWxlUmVxdWVzdC5NZXRhZGF0YUVudHJ5Eg4KBnB1YmxpYxgHIAEoCBIuCgpleHBpcmVzX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIRCglmaWxlX3R5cGUYCSABKAkSEQoJcGFyZW50X2lkGAogASgJEh0KCmNyZWF0b3JfaWQYCyABKAsyCS50eXBlcy5JRBovCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEiRgoSQ3JlYXRlRmlsZVJlc3BvbnNlEhwKBGZpbGUYASABKAsyDi5maWxlcy52MS5GaWxlEhIKCnVwbG9hZF91cmwYAiABKAkiSAoYQ29uZmlybUZpbGVVcGxvYWRSZXF1ZXN0EhoKB2ZpbGVfaWQYASABKAsyCS50eXBlcy5JRBIQCghjaGVja3N1bRgCIAEoCSI5ChlDb25maXJtRmlsZVVwbG9hZFJlc3BvbnNlEhwKBGZpbGUYASABKAsyDi5maWxlcy52MS5GaWxlIjgKGkNhbmNlbFBlbmRpbmdVcGxvYWRSZXF1ZXN0EhoKB2ZpbGVfaWQYASABKAsyCS50eXBlcy5JRCJGChFEZWxldGVGaWxlUmVxdWVzdBIaCgdmaWxlX2lkGAEgASgLMgkudHlwZXMuSUQSFQoNY2FsbGVyX21vZHVsZRgCIAEoCSLEAQoZVXBkYXRlRmlsZU1ldGFkYXRhUmVxdWVzdBIaCgdmaWxlX2lkGAEgASgLMgkudHlwZXMuSUQSQwoIbWV0YWRhdGEYAiADKAsyMS5maWxlcy52MS5VcGRhdGVGaWxlTWV0YWRhdGFSZXF1ZXN0Lk1ldGFkYXRhRW50cnkSFQoNY2FsbGVyX21vZHVsZRgDIAEoCRovCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEiOgoaVXBkYXRlRmlsZU1ldGFkYXRhUmVzcG9uc2USHAoEZmlsZRgBIAEoCzIOLmZpbGVzLnYxLkZpbGUiZgoPTW92ZUZpbGVSZXF1ZXN0EhoKB2ZpbGVfaWQYASABKAsyCS50eXBlcy5JRBIgCg1uZXdfcGFyZW50X2lkGAIgASgLMgkudHlwZXMuSUQSFQoNY2FsbGVyX21vZHVsZRgDIAEoCSIwChBNb3ZlRmlsZVJlc3BvbnNlEhwKBGZpbGUYASABKAsyDi5maWxlcy52MS5GaWxlIl8KEFNoYXJlRmlsZVJlcXVlc3QSGgoHZmlsZV9pZBgBIAEoCzIJLnR5cGVzLklEEhsKCHVzZXJfaWRzGAIgAygLMgkudHlwZXMuSUQSEgoKcGVybWlzc2lvbhgDIAEoCSJMChFTaGFyZUZpbGVSZXNwb25zZRIcCgRmaWxlGAEgASgLMg4uZmlsZXMudjEuRmlsZRIZChFzaGFyZWRfd2l0aF9jb3VudBgCIAEoBSJhChJVbnNoYXJlRmlsZVJlcXVlc3QSGgoHZmlsZV9pZBgBIAEoCzIJLnR5cGVzLklEEhsKCHVzZXJfaWRzGAIgAygLMgkudHlwZXMuSUQSEgoKcGVybWlzc2lvbhgDIAEoCSJKChNVbnNoYXJlRmlsZVJlc3BvbnNlEhwKBGZpbGUYASABKAsyDi5maWxlcy52MS5GaWxlEhUKDXJlbW92ZWRfY291bnQYAiABKAUiQAoSQ3JlYXRlRmlsZXNSZXF1ZXN0EioKBWZpbGVzGAEgAygLMhsuZmlsZXMudjEuQ3JlYXRlRmlsZVJlcXVlc3QiRAoTQ3JlYXRlRmlsZXNSZXNwb25zZRItCgdyZXN1bHRzGAEgAygLMhwuZmlsZXMudjEuQ3JlYXRlRmlsZVJlc3BvbnNlIjEKEkRlbGV0ZUZpbGVzUmVxdWVzdBIbCghmaWxlX2lkcxgBIAMoCzIJLnR5cGVzLklEIlsKE0RlbGV0ZUZpbGVzUmVzcG9uc2USFQoNZGVsZXRlZF9jb3VudBgBIAEoBRIdCgpmYWlsZWRfaWRzGAIgAygLMgkudHlwZXMuSUQSDgoGZXJyb3JzGAMgAygJIiwKDkdldEZpbGVSZXF1ZXN0EhoKB2ZpbGVfaWQYASABKAsyCS50eXBlcy5JRCIvCg9HZXRGaWxlUmVzcG9uc2USHAoEZmlsZRgBIAEoCzIOLmZpbGVzLnYxLkZpbGUiyQEKEExpc3RGaWxlc1JlcXVlc3QSEwoLZW50aXR5X3R5cGUYASABKAkSHAoJZW50aXR5X2lkGAIgASgLMgkudHlwZXMuSUQSDgoGc3RhdHVzGAMgASgJEhEKCWZpbGVfdHlwZRgEIAEoCRIdCgpwYXJlbnRfaWRzGAUgAygLMgkudHlwZXMuSUQSDgoGcHVibGljGAYgASgIEg0KBWxpbWl0GAcgASgFEg4KBm9mZnNldBgIIAEoBRIRCglmaWxlX25hbWUYCSABKAkiQQoRTGlzdEZpbGVzUmVzcG9uc2USHQoFZmlsZXMYASADKAsyDi5maWxlcy52MS5GaWxlEg0KBXRvdGFsGAIgASgFIj4KCUVudGl0eUtleRITCgtlbnRpdHlfdHlwZRgBIAEoCRIcCgllbnRpdHlfaWQYAiABKAsyCS50eXBlcy5JRCJzChpMaXN0RmlsZXNCeUVudGl0aWVzUmVxdWVzdBIoCgtlbnRpdHlfa2V5cxgBIAMoCzITLmZpbGVzLnYxLkVudGl0eUtleRIRCglmaWxlX3R5cGUYAiABKAkSGAoQcGVyX2VudGl0eV9saW1pdBgDIAEoBSJkChBFbnRpdHlGaWxlc0dyb3VwEhMKC2VudGl0eV90eXBlGAEgASgJEhwKCWVudGl0eV9pZBgCIAEoCzIJLnR5cGVzLklEEh0KBWZpbGVzGAMgAygLMg4uZmlsZXMudjEuRmlsZSJJChtMaXN0RmlsZXNCeUVudGl0aWVzUmVzcG9uc2USKgoGZ3JvdXBzGAEgAygLMhouZmlsZXMudjEuRW50aXR5RmlsZXNHcm91cCJOChhHZW5lcmF0ZUFjY2Vzc1VSTFJlcXVlc3QSGgoHZmlsZV9pZBgBIAEoCzIJLnR5cGVzLklEEhYKDmV4cGlyeV9zZWNvbmRzGAIgASgFIlgKGUdlbmVyYXRlQWNjZXNzVVJMUmVzcG9uc2USCwoDdXJsGAEgASgJEi4KCmV4cGlyZXNfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIhgKFkdldFN0b3JhZ2VRdW90YVJlcXVlc3QiiQEKF0dldFN0b3JhZ2VRdW90YVJlc3BvbnNlEhMKC3F1b3RhX2J5dGVzGAEgASgDEhIKCnVzZWRfYnl0ZXMYAiABKAMSFwoPYXZhaWxhYmxlX2J5dGVzGAMgASgDEhIKCmZpbGVfY291bnQYBCABKAUSGAoQdXNhZ2VfcGVyY2VudGFnZRgFIAEoASLXAgoZQ3JlYXRlSW50ZXJuYWxGaWxlUmVxdWVzdBIRCglmaWxlX25hbWUYASABKAkSEQoJZmlsZV9zaXplGAIgASgDEhEKCW1pbWVfdHlwZRgDIAEoCRITCgtlbnRpdHlfdHlwZRgEIAEoCRIcCgllbnRpdHlfaWQYBSABKAsyCS50eXBlcy5JRBJDCghtZXRhZGF0YRgGIAMoCzIxLmZpbGVzLnYxLkNyZWF0ZUludGVybmFsRmlsZVJlcXVlc3QuTWV0YWRhdGFFbnRyeRIVCg1jYWxsZXJfbW9kdWxlGAcgASgJEiIKD29yZ2FuaXphdGlvbl9pZBgIIAEoCzIJLnR5cGVzLklEEh0KCmNyZWF0b3JfaWQYCSABKAsyCS50eXBlcy5JRBovCg1NZXRhZGF0YUVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEiZwogQ29uZmlybUludGVybmFsRmlsZVVwbG9hZFJlcXVlc3QSGgoHZmlsZV9pZBgBIAEoCzIJLnR5cGVzLklEEhAKCGNoZWNrc3VtGAIgASgJEhUKDWNhbGxlcl9tb2R1bGUYAyABKAkiVwoiUmVnZW5lcmF0ZUludGVybmFsVXBsb2FkVVJMUmVxdWVzdBIaCgdmaWxlX2lkGAEgASgLMgkudHlwZXMuSUQSFQoNY2FsbGVyX21vZHVsZRgCIAEoCSI5CiNSZWdlbmVyYXRlSW50ZXJuYWxVcGxvYWRVUkxSZXNwb25zZRISCgp1cGxvYWRfdXJsGAEgASgJKoMBChRGaWxlUGVybWlzc2lvbkFjdGlvbhImCiJGSUxFX1BFUk1JU1NJT05fQUNUSU9OX1VOU1BFQ0lGSUVEEAASIAocRklMRV9QRVJNSVNTSU9OX0FDVElPTl9HUkFOVBABEiEKHUZJTEVfUEVSTUlTU0lPTl9BQ1RJT05fUkVWT0tFEAIy5QgKE0ZpbGVDb21tYW5kc1NlcnZpY2USRwoKQ3JlYXRlRmlsZRIbLmZpbGVzLnYxLkNyZWF0ZUZpbGVSZXF1ZXN0GhwuZmlsZXMudjEuQ3JlYXRlRmlsZVJlc3BvbnNlElwKEUNvbmZpcm1GaWxlVXBsb2FkEiIuZmlsZXMudjEuQ29uZmlybUZpbGVVcGxvYWRSZXF1ZXN0GiMuZmlsZXMudjEuQ29uZmlybUZpbGVVcGxvYWRSZXNwb25zZRJTChNDYW5jZWxQZW5kaW5nVXBsb2FkEiQuZmlsZXMudjEuQ2FuY2VsUGVuZGluZ1VwbG9hZFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkSQQoKRGVsZXRlRmlsZRIbLmZpbGVzLnYxLkRlbGV0ZUZpbGVSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5El8KElVwZGF0ZUZpbGVNZXRhZGF0YRIjLmZpbGVzLnYxLlVwZGF0ZUZpbGVNZXRhZGF0YVJlcXVlc3QaJC5maWxlcy52MS5VcGRhdGVGaWxlTWV0YWRhdGFSZXNwb25zZRJBCghNb3ZlRmlsZRIZLmZpbGVzLnYxLk1vdmVGaWxlUmVxdWVzdBoaLmZpbGVzLnYxLk1vdmVGaWxlUmVzcG9uc2USRAoJU2hhcmVGaWxlEhouZmlsZXMudjEuU2hhcmVGaWxlUmVxdWVzdBobLmZpbGVzLnYxLlNoYXJlRmlsZVJlc3BvbnNlEkoKC1Vuc2hhcmVGaWxlEhwuZmlsZXMudjEuVW5zaGFyZUZpbGVSZXF1ZXN0Gh0uZmlsZXMudjEuVW5zaGFyZUZpbGVSZXNwb25zZRJKCgtDcmVhdGVGaWxlcxIcLmZpbGVzLnYxLkNyZWF0ZUZpbGVzUmVxdWVzdBodLmZpbGVzLnYxLkNyZWF0ZUZpbGVzUmVzcG9uc2USSgoLRGVsZXRlRmlsZXMSHC5maWxlcy52MS5EZWxldGVGaWxlc1JlcXVlc3QaHS5maWxlcy52MS5EZWxldGVGaWxlc1Jlc3BvbnNlElcKEkNyZWF0ZUludGVybmFsRmlsZRIjLmZpbGVzLnYxLkNyZWF0ZUludGVybmFsRmlsZVJlcXVlc3QaHC5maWxlcy52MS5DcmVhdGVGaWxlUmVzcG9uc2USbAoZQ29uZmlybUludGVybmFsRmlsZVVwbG9hZBIqLmZpbGVzLnYxLkNvbmZpcm1JbnRlcm5hbEZpbGVVcGxvYWRSZXF1ZXN0GiMuZmlsZXMudjEuQ29uZmlybUZpbGVVcGxvYWRSZXNwb25zZRJ6ChtSZWdlbmVyYXRlSW50ZXJuYWxVcGxvYWRVUkwSLC5maWxlcy52MS5SZWdlbmVyYXRlSW50ZXJuYWxVcGxvYWRVUkxSZXF1ZXN0Gi0uZmlsZXMudjEuUmVnZW5lcmF0ZUludGVybmFsVXBsb2FkVVJMUmVzcG9uc2UytAMKEkZpbGVRdWVyaWVzU2VydmljZRI+CgdHZXRGaWxlEhguZmlsZXMudjEuR2V0RmlsZVJlcXVlc3QaGS5maWxlcy52MS5HZXRGaWxlUmVzcG9uc2USRAoJTGlzdEZpbGVzEhouZmlsZXMudjEuTGlzdEZpbGVzUmVxdWVzdBobLmZpbGVzLnYxLkxpc3RGaWxlc1Jlc3BvbnNlElwKEUdlbmVyYXRlQWNjZXNzVVJMEiIuZmlsZXMudjEuR2VuZXJhdGVBY2Nlc3NVUkxSZXF1ZXN0GiMuZmlsZXMudjEuR2VuZXJhdGVBY2Nlc3NVUkxSZXNwb25zZRJWCg9HZXRTdG9yYWdlUXVvdGESIC5maWxlcy52MS5HZXRTdG9yYWdlUXVvdGFSZXF1ZXN0GiEuZmlsZXMudjEuR2V0U3RvcmFnZVF1b3RhUmVzcG9uc2USYgoTTGlzdEZpbGVzQnlFbnRpdGllcxIkLmZpbGVzLnYxLkxpc3RGaWxlc0J5RW50aXRpZXNSZXF1ZXN0GiUuZmlsZXMudjEuTGlzdEZpbGVzQnlFbnRpdGllc1Jlc3BvbnNlQi9aLXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWZpbGVzL2FwaS92MTtmaWxlc192MWIIZWRpdGlvbnNw6Ac", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_types]);

/**
 * File represents a managed file in the system
 *
 * @generated from message files.v1.File
 */
export type File = Message<"files.v1.File"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;

  /**
   * @generated from field: string storage_key = 3;
   */
  storageKey: string;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 5;
   */
  fileSize: bigint;

  /**
   * @generated from field: string mime_type = 6;
   */
  mimeType: string;

  /**
   * @generated from field: string checksum = 7;
   */
  checksum: string;

  /**
   * @generated from field: string creator_id = 8;
   */
  creatorId: string;

  /**
   * @generated from field: bool public = 9;
   */
  public: boolean;

  /**
   * @generated from field: string entity_type = 10;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 11;
   */
  entityId?: ID;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 14;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp;

  /**
   * "Regular" or "Directory"
   *
   * @generated from field: string file_type = 17;
   */
  fileType: string;

  /**
   * Parent folder ID
   *
   * @generated from field: string parent_id = 18;
   */
  parentId: string;

  /**
   * URL for uploading the file content
   *
   * @generated from field: string upload_url = 19;
   */
  uploadUrl: string;

  /**
   * When the upload URL expires
   *
   * @generated from field: google.protobuf.Timestamp upload_expiry = 20;
   */
  uploadExpiry?: Timestamp;

  /**
   * Soft delete timestamp
   *
   * @generated from field: google.protobuf.Timestamp deleted_at = 21;
   */
  deletedAt?: Timestamp;

  /**
   * S3 version ID of current version
   *
   * @generated from field: string current_version_id = 22;
   */
  currentVersionId: string;

  /**
   * Cached count of versions
   *
   * @generated from field: int32 version_count = 23;
   */
  versionCount: number;

  /**
   * S3 ETag for content identification
   *
   * @generated from field: string unique_content_id = 24;
   */
  uniqueContentId: string;
};

/**
 * Describes the message files.v1.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 0);

/**
 * FilePermissionChange represents a single permission change
 *
 * @generated from message files.v1.FilePermissionChange
 */
export type FilePermissionChange = Message<"files.v1.FilePermissionChange"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string permission = 2;
   */
  permission: string;

  /**
   * @generated from field: files.v1.FilePermissionAction action = 3;
   */
  action: FilePermissionAction;
};

/**
 * Describes the message files.v1.FilePermissionChange.
 * Use `create(FilePermissionChangeSchema)` to create a new message.
 */
export const FilePermissionChangeSchema: GenMessage<FilePermissionChange> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 1);

/**
 * CreateFileRequest is the request for creating a new file
 *
 * @generated from message files.v1.CreateFileRequest
 */
export type CreateFileRequest = Message<"files.v1.CreateFileRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 5;
   */
  entityId?: ID;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: bool public = 7;
   */
  public: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp;

  /**
   * "Regular" or "Directory"
   *
   * @generated from field: string file_type = 9;
   */
  fileType: string;

  /**
   * Parent folder ID
   *
   * @generated from field: string parent_id = 10;
   */
  parentId: string;

  /**
   * Optional creator ID (if not provided, uses JWT context)
   *
   * @generated from field: types.ID creator_id = 11;
   */
  creatorId?: ID;
};

/**
 * Describes the message files.v1.CreateFileRequest.
 * Use `create(CreateFileRequestSchema)` to create a new message.
 */
export const CreateFileRequestSchema: GenMessage<CreateFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 2);

/**
 * CreateFileResponse contains the created file and upload URL
 *
 * @generated from message files.v1.CreateFileResponse
 */
export type CreateFileResponse = Message<"files.v1.CreateFileResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: string upload_url = 2;
   */
  uploadUrl: string;
};

/**
 * Describes the message files.v1.CreateFileResponse.
 * Use `create(CreateFileResponseSchema)` to create a new message.
 */
export const CreateFileResponseSchema: GenMessage<CreateFileResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 3);

/**
 * ConfirmFileUploadRequest confirms a file was uploaded
 *
 * @generated from message files.v1.ConfirmFileUploadRequest
 */
export type ConfirmFileUploadRequest = Message<"files.v1.ConfirmFileUploadRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: string checksum = 2;
   */
  checksum: string;
};

/**
 * Describes the message files.v1.ConfirmFileUploadRequest.
 * Use `create(ConfirmFileUploadRequestSchema)` to create a new message.
 */
export const ConfirmFileUploadRequestSchema: GenMessage<ConfirmFileUploadRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 4);

/**
 * ConfirmFileUploadResponse contains the confirmed file
 *
 * @generated from message files.v1.ConfirmFileUploadResponse
 */
export type ConfirmFileUploadResponse = Message<"files.v1.ConfirmFileUploadResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message files.v1.ConfirmFileUploadResponse.
 * Use `create(ConfirmFileUploadResponseSchema)` to create a new message.
 */
export const ConfirmFileUploadResponseSchema: GenMessage<ConfirmFileUploadResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 5);

/**
 * CancelPendingUploadRequest cancels a pending file upload
 *
 * @generated from message files.v1.CancelPendingUploadRequest
 */
export type CancelPendingUploadRequest = Message<"files.v1.CancelPendingUploadRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;
};

/**
 * Describes the message files.v1.CancelPendingUploadRequest.
 * Use `create(CancelPendingUploadRequestSchema)` to create a new message.
 */
export const CancelPendingUploadRequestSchema: GenMessage<CancelPendingUploadRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 6);

/**
 * DeleteFileRequest deletes a file
 *
 * @generated from message files.v1.DeleteFileRequest
 */
export type DeleteFileRequest = Message<"files.v1.DeleteFileRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * Optional module identifier ("trade", "sales", etc.)
   *
   * @generated from field: string caller_module = 2;
   */
  callerModule: string;
};

/**
 * Describes the message files.v1.DeleteFileRequest.
 * Use `create(DeleteFileRequestSchema)` to create a new message.
 */
export const DeleteFileRequestSchema: GenMessage<DeleteFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 7);

/**
 * UpdateFileMetadataRequest updates file metadata
 *
 * @generated from message files.v1.UpdateFileMetadataRequest
 */
export type UpdateFileMetadataRequest = Message<"files.v1.UpdateFileMetadataRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };

  /**
   * Optional module identifier ("trade", "sales", etc.)
   *
   * @generated from field: string caller_module = 3;
   */
  callerModule: string;
};

/**
 * Describes the message files.v1.UpdateFileMetadataRequest.
 * Use `create(UpdateFileMetadataRequestSchema)` to create a new message.
 */
export const UpdateFileMetadataRequestSchema: GenMessage<UpdateFileMetadataRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 8);

/**
 * UpdateFileMetadataResponse contains the updated file
 *
 * @generated from message files.v1.UpdateFileMetadataResponse
 */
export type UpdateFileMetadataResponse = Message<"files.v1.UpdateFileMetadataResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message files.v1.UpdateFileMetadataResponse.
 * Use `create(UpdateFileMetadataResponseSchema)` to create a new message.
 */
export const UpdateFileMetadataResponseSchema: GenMessage<UpdateFileMetadataResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 9);

/**
 * MoveFileRequest moves a file to a new parent directory
 *
 * @generated from message files.v1.MoveFileRequest
 */
export type MoveFileRequest = Message<"files.v1.MoveFileRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * Empty string means root directory
   *
   * @generated from field: types.ID new_parent_id = 2;
   */
  newParentId?: ID;

  /**
   * Optional module identifier ("trade", "sales", etc.)
   *
   * @generated from field: string caller_module = 3;
   */
  callerModule: string;
};

/**
 * Describes the message files.v1.MoveFileRequest.
 * Use `create(MoveFileRequestSchema)` to create a new message.
 */
export const MoveFileRequestSchema: GenMessage<MoveFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 10);

/**
 * MoveFileResponse contains the moved file
 *
 * @generated from message files.v1.MoveFileResponse
 */
export type MoveFileResponse = Message<"files.v1.MoveFileResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message files.v1.MoveFileResponse.
 * Use `create(MoveFileResponseSchema)` to create a new message.
 */
export const MoveFileResponseSchema: GenMessage<MoveFileResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 11);

/**
 * ShareFileRequest shares a file with specified users
 *
 * @generated from message files.v1.ShareFileRequest
 */
export type ShareFileRequest = Message<"files.v1.ShareFileRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: repeated types.ID user_ids = 2;
   */
  userIds: ID[];

  /**
   * "fileRead", "fileWrite", "fileDelete"
   *
   * @generated from field: string permission = 3;
   */
  permission: string;
};

/**
 * Describes the message files.v1.ShareFileRequest.
 * Use `create(ShareFileRequestSchema)` to create a new message.
 */
export const ShareFileRequestSchema: GenMessage<ShareFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 12);

/**
 * ShareFileResponse contains the result of sharing a file
 *
 * @generated from message files.v1.ShareFileResponse
 */
export type ShareFileResponse = Message<"files.v1.ShareFileResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: int32 shared_with_count = 2;
   */
  sharedWithCount: number;
};

/**
 * Describes the message files.v1.ShareFileResponse.
 * Use `create(ShareFileResponseSchema)` to create a new message.
 */
export const ShareFileResponseSchema: GenMessage<ShareFileResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 13);

/**
 * UnshareFileRequest removes file access from specified users
 *
 * @generated from message files.v1.UnshareFileRequest
 */
export type UnshareFileRequest = Message<"files.v1.UnshareFileRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: repeated types.ID user_ids = 2;
   */
  userIds: ID[];

  /**
   * @generated from field: string permission = 3;
   */
  permission: string;
};

/**
 * Describes the message files.v1.UnshareFileRequest.
 * Use `create(UnshareFileRequestSchema)` to create a new message.
 */
export const UnshareFileRequestSchema: GenMessage<UnshareFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 14);

/**
 * UnshareFileResponse contains the result of unsharing a file
 *
 * @generated from message files.v1.UnshareFileResponse
 */
export type UnshareFileResponse = Message<"files.v1.UnshareFileResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: int32 removed_count = 2;
   */
  removedCount: number;
};

/**
 * Describes the message files.v1.UnshareFileResponse.
 * Use `create(UnshareFileResponseSchema)` to create a new message.
 */
export const UnshareFileResponseSchema: GenMessage<UnshareFileResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 15);

/**
 * CreateFilesRequest for bulk file creation
 *
 * @generated from message files.v1.CreateFilesRequest
 */
export type CreateFilesRequest = Message<"files.v1.CreateFilesRequest"> & {
  /**
   * @generated from field: repeated files.v1.CreateFileRequest files = 1;
   */
  files: CreateFileRequest[];
};

/**
 * Describes the message files.v1.CreateFilesRequest.
 * Use `create(CreateFilesRequestSchema)` to create a new message.
 */
export const CreateFilesRequestSchema: GenMessage<CreateFilesRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 16);

/**
 * CreateFilesResponse for bulk file creation
 *
 * @generated from message files.v1.CreateFilesResponse
 */
export type CreateFilesResponse = Message<"files.v1.CreateFilesResponse"> & {
  /**
   * @generated from field: repeated files.v1.CreateFileResponse results = 1;
   */
  results: CreateFileResponse[];
};

/**
 * Describes the message files.v1.CreateFilesResponse.
 * Use `create(CreateFilesResponseSchema)` to create a new message.
 */
export const CreateFilesResponseSchema: GenMessage<CreateFilesResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 17);

/**
 * DeleteFilesRequest for bulk file deletion
 *
 * @generated from message files.v1.DeleteFilesRequest
 */
export type DeleteFilesRequest = Message<"files.v1.DeleteFilesRequest"> & {
  /**
   * @generated from field: repeated types.ID file_ids = 1;
   */
  fileIds: ID[];
};

/**
 * Describes the message files.v1.DeleteFilesRequest.
 * Use `create(DeleteFilesRequestSchema)` to create a new message.
 */
export const DeleteFilesRequestSchema: GenMessage<DeleteFilesRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 18);

/**
 * DeleteFilesResponse for bulk file deletion
 *
 * @generated from message files.v1.DeleteFilesResponse
 */
export type DeleteFilesResponse = Message<"files.v1.DeleteFilesResponse"> & {
  /**
   * @generated from field: int32 deleted_count = 1;
   */
  deletedCount: number;

  /**
   * @generated from field: repeated types.ID failed_ids = 2;
   */
  failedIds: ID[];

  /**
   * @generated from field: repeated string errors = 3;
   */
  errors: string[];
};

/**
 * Describes the message files.v1.DeleteFilesResponse.
 * Use `create(DeleteFilesResponseSchema)` to create a new message.
 */
export const DeleteFilesResponseSchema: GenMessage<DeleteFilesResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 19);

/**
 * GetFileRequest retrieves a file by ID
 *
 * @generated from message files.v1.GetFileRequest
 */
export type GetFileRequest = Message<"files.v1.GetFileRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;
};

/**
 * Describes the message files.v1.GetFileRequest.
 * Use `create(GetFileRequestSchema)` to create a new message.
 */
export const GetFileRequestSchema: GenMessage<GetFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 20);

/**
 * GetFileResponse contains the requested file
 *
 * @generated from message files.v1.GetFileResponse
 */
export type GetFileResponse = Message<"files.v1.GetFileResponse"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;
};

/**
 * Describes the message files.v1.GetFileResponse.
 * Use `create(GetFileResponseSchema)` to create a new message.
 */
export const GetFileResponseSchema: GenMessage<GetFileResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 21);

/**
 * ListFilesRequest lists files with filters
 *
 * @generated from message files.v1.ListFilesRequest
 */
export type ListFilesRequest = Message<"files.v1.ListFilesRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 2;
   */
  entityId?: ID;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * "Regular" or "Directory"
   *
   * @generated from field: string file_type = 4;
   */
  fileType: string;

  /**
   * Filter by parent directory
   *
   * @generated from field: repeated types.ID parent_ids = 5;
   */
  parentIds: ID[];

  /**
   * @generated from field: bool public = 6;
   */
  public: boolean;

  /**
   * @generated from field: int32 limit = 7;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 8;
   */
  offset: number;

  /**
   * Filter by file name
   *
   * @generated from field: string file_name = 9;
   */
  fileName: string;
};

/**
 * Describes the message files.v1.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema: GenMessage<ListFilesRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 22);

/**
 * ListFilesResponse contains the list of files in a connection format
 *
 * @generated from message files.v1.ListFilesResponse
 */
export type ListFilesResponse = Message<"files.v1.ListFilesResponse"> & {
  /**
   * @generated from field: repeated files.v1.File files = 1;
   */
  files: File[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message files.v1.ListFilesResponse.
 * Use `create(ListFilesResponseSchema)` to create a new message.
 */
export const ListFilesResponseSchema: GenMessage<ListFilesResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 23);

/**
 * @generated from message files.v1.EntityKey
 */
export type EntityKey = Message<"files.v1.EntityKey"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 2;
   */
  entityId?: ID;
};

/**
 * Describes the message files.v1.EntityKey.
 * Use `create(EntityKeySchema)` to create a new message.
 */
export const EntityKeySchema: GenMessage<EntityKey> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 24);

/**
 * @generated from message files.v1.ListFilesByEntitiesRequest
 */
export type ListFilesByEntitiesRequest = Message<"files.v1.ListFilesByEntitiesRequest"> & {
  /**
   * @generated from field: repeated files.v1.EntityKey entity_keys = 1;
   */
  entityKeys: EntityKey[];

  /**
   * @generated from field: string file_type = 2;
   */
  fileType: string;

  /**
   * @generated from field: int32 per_entity_limit = 3;
   */
  perEntityLimit: number;
};

/**
 * Describes the message files.v1.ListFilesByEntitiesRequest.
 * Use `create(ListFilesByEntitiesRequestSchema)` to create a new message.
 */
export const ListFilesByEntitiesRequestSchema: GenMessage<ListFilesByEntitiesRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 25);

/**
 * @generated from message files.v1.EntityFilesGroup
 */
export type EntityFilesGroup = Message<"files.v1.EntityFilesGroup"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 2;
   */
  entityId?: ID;

  /**
   * @generated from field: repeated files.v1.File files = 3;
   */
  files: File[];
};

/**
 * Describes the message files.v1.EntityFilesGroup.
 * Use `create(EntityFilesGroupSchema)` to create a new message.
 */
export const EntityFilesGroupSchema: GenMessage<EntityFilesGroup> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 26);

/**
 * @generated from message files.v1.ListFilesByEntitiesResponse
 */
export type ListFilesByEntitiesResponse = Message<"files.v1.ListFilesByEntitiesResponse"> & {
  /**
   * @generated from field: repeated files.v1.EntityFilesGroup groups = 1;
   */
  groups: EntityFilesGroup[];
};

/**
 * Describes the message files.v1.ListFilesByEntitiesResponse.
 * Use `create(ListFilesByEntitiesResponseSchema)` to create a new message.
 */
export const ListFilesByEntitiesResponseSchema: GenMessage<ListFilesByEntitiesResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 27);

/**
 * GenerateAccessURLRequest generates an access URL for a file
 *
 * @generated from message files.v1.GenerateAccessURLRequest
 */
export type GenerateAccessURLRequest = Message<"files.v1.GenerateAccessURLRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * Default: 3600 (1 hour)
   *
   * @generated from field: int32 expiry_seconds = 2;
   */
  expirySeconds: number;
};

/**
 * Describes the message files.v1.GenerateAccessURLRequest.
 * Use `create(GenerateAccessURLRequestSchema)` to create a new message.
 */
export const GenerateAccessURLRequestSchema: GenMessage<GenerateAccessURLRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 28);

/**
 * GenerateAccessURLResponse contains the generated URL
 *
 * @generated from message files.v1.GenerateAccessURLResponse
 */
export type GenerateAccessURLResponse = Message<"files.v1.GenerateAccessURLResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message files.v1.GenerateAccessURLResponse.
 * Use `create(GenerateAccessURLResponseSchema)` to create a new message.
 */
export const GenerateAccessURLResponseSchema: GenMessage<GenerateAccessURLResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 29);

/**
 * GetStorageQuotaRequest gets the storage quota for the organization
 *
 * Organization ID is taken from auth context
 *
 * @generated from message files.v1.GetStorageQuotaRequest
 */
export type GetStorageQuotaRequest = Message<"files.v1.GetStorageQuotaRequest"> & {
};

/**
 * Describes the message files.v1.GetStorageQuotaRequest.
 * Use `create(GetStorageQuotaRequestSchema)` to create a new message.
 */
export const GetStorageQuotaRequestSchema: GenMessage<GetStorageQuotaRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 30);

/**
 * GetStorageQuotaResponse contains quota information
 *
 * @generated from message files.v1.GetStorageQuotaResponse
 */
export type GetStorageQuotaResponse = Message<"files.v1.GetStorageQuotaResponse"> & {
  /**
   * @generated from field: int64 quota_bytes = 1;
   */
  quotaBytes: bigint;

  /**
   * @generated from field: int64 used_bytes = 2;
   */
  usedBytes: bigint;

  /**
   * @generated from field: int64 available_bytes = 3;
   */
  availableBytes: bigint;

  /**
   * @generated from field: int32 file_count = 4;
   */
  fileCount: number;

  /**
   * @generated from field: double usage_percentage = 5;
   */
  usagePercentage: number;
};

/**
 * Describes the message files.v1.GetStorageQuotaResponse.
 * Use `create(GetStorageQuotaResponseSchema)` to create a new message.
 */
export const GetStorageQuotaResponseSchema: GenMessage<GetStorageQuotaResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 31);

/**
 * CreateInternalFileRequest creates a file on behalf of a backend module (no user context required)
 *
 * @generated from message files.v1.CreateInternalFileRequest
 */
export type CreateInternalFileRequest = Message<"files.v1.CreateInternalFileRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: types.ID entity_id = 5;
   */
  entityId?: ID;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: string caller_module = 7;
   */
  callerModule: string;

  /**
   * @generated from field: types.ID organization_id = 8;
   */
  organizationId?: ID;

  /**
   * @generated from field: types.ID creator_id = 9;
   */
  creatorId?: ID;
};

/**
 * Describes the message files.v1.CreateInternalFileRequest.
 * Use `create(CreateInternalFileRequestSchema)` to create a new message.
 */
export const CreateInternalFileRequestSchema: GenMessage<CreateInternalFileRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 32);

/**
 * ConfirmInternalFileUploadRequest confirms upload for a module-managed file (no user context required)
 *
 * @generated from message files.v1.ConfirmInternalFileUploadRequest
 */
export type ConfirmInternalFileUploadRequest = Message<"files.v1.ConfirmInternalFileUploadRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: string checksum = 2;
   */
  checksum: string;

  /**
   * @generated from field: string caller_module = 3;
   */
  callerModule: string;
};

/**
 * Describes the message files.v1.ConfirmInternalFileUploadRequest.
 * Use `create(ConfirmInternalFileUploadRequestSchema)` to create a new message.
 */
export const ConfirmInternalFileUploadRequestSchema: GenMessage<ConfirmInternalFileUploadRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 33);

/**
 * RegenerateInternalUploadURLRequest regenerates a presigned upload URL for an existing file
 *
 * @generated from message files.v1.RegenerateInternalUploadURLRequest
 */
export type RegenerateInternalUploadURLRequest = Message<"files.v1.RegenerateInternalUploadURLRequest"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: string caller_module = 2;
   */
  callerModule: string;
};

/**
 * Describes the message files.v1.RegenerateInternalUploadURLRequest.
 * Use `create(RegenerateInternalUploadURLRequestSchema)` to create a new message.
 */
export const RegenerateInternalUploadURLRequestSchema: GenMessage<RegenerateInternalUploadURLRequest> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 34);

/**
 * RegenerateInternalUploadURLResponse contains the new upload URL
 *
 * @generated from message files.v1.RegenerateInternalUploadURLResponse
 */
export type RegenerateInternalUploadURLResponse = Message<"files.v1.RegenerateInternalUploadURLResponse"> & {
  /**
   * @generated from field: string upload_url = 1;
   */
  uploadUrl: string;
};

/**
 * Describes the message files.v1.RegenerateInternalUploadURLResponse.
 * Use `create(RegenerateInternalUploadURLResponseSchema)` to create a new message.
 */
export const RegenerateInternalUploadURLResponseSchema: GenMessage<RegenerateInternalUploadURLResponse> = /*@__PURE__*/
  messageDesc(file_files_v1_file, 35);

/**
 * FilePermissionAction represents the action to take on a permission
 *
 * @generated from enum files.v1.FilePermissionAction
 */
export enum FilePermissionAction {
  /**
   * @generated from enum value: FILE_PERMISSION_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_PERMISSION_ACTION_GRANT = 1;
   */
  GRANT = 1,

  /**
   * @generated from enum value: FILE_PERMISSION_ACTION_REVOKE = 2;
   */
  REVOKE = 2,
}

/**
 * Describes the enum files.v1.FilePermissionAction.
 */
export const FilePermissionActionSchema: GenEnum<FilePermissionAction> = /*@__PURE__*/
  enumDesc(file_files_v1_file, 0);

/**
 * FileCommandsService handles file write operations
 *
 * @generated from service files.v1.FileCommandsService
 */
export const FileCommandsService: GenService<{
  /**
   * Single file operations
   *
   * @generated from rpc files.v1.FileCommandsService.CreateFile
   */
  createFile: {
    methodKind: "unary";
    input: typeof CreateFileRequestSchema;
    output: typeof CreateFileResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.ConfirmFileUpload
   */
  confirmFileUpload: {
    methodKind: "unary";
    input: typeof ConfirmFileUploadRequestSchema;
    output: typeof ConfirmFileUploadResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.CancelPendingUpload
   */
  cancelPendingUpload: {
    methodKind: "unary";
    input: typeof CancelPendingUploadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.DeleteFile
   */
  deleteFile: {
    methodKind: "unary";
    input: typeof DeleteFileRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.UpdateFileMetadata
   */
  updateFileMetadata: {
    methodKind: "unary";
    input: typeof UpdateFileMetadataRequestSchema;
    output: typeof UpdateFileMetadataResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.MoveFile
   */
  moveFile: {
    methodKind: "unary";
    input: typeof MoveFileRequestSchema;
    output: typeof MoveFileResponseSchema;
  },
  /**
   * Permission management
   *
   * @generated from rpc files.v1.FileCommandsService.ShareFile
   */
  shareFile: {
    methodKind: "unary";
    input: typeof ShareFileRequestSchema;
    output: typeof ShareFileResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.UnshareFile
   */
  unshareFile: {
    methodKind: "unary";
    input: typeof UnshareFileRequestSchema;
    output: typeof UnshareFileResponseSchema;
  },
  /**
   * Bulk operations
   *
   * @generated from rpc files.v1.FileCommandsService.CreateFiles
   */
  createFiles: {
    methodKind: "unary";
    input: typeof CreateFilesRequestSchema;
    output: typeof CreateFilesResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.DeleteFiles
   */
  deleteFiles: {
    methodKind: "unary";
    input: typeof DeleteFilesRequestSchema;
    output: typeof DeleteFilesResponseSchema;
  },
  /**
   * Internal operations (service-to-service, no user context required)
   *
   * @generated from rpc files.v1.FileCommandsService.CreateInternalFile
   */
  createInternalFile: {
    methodKind: "unary";
    input: typeof CreateInternalFileRequestSchema;
    output: typeof CreateFileResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.ConfirmInternalFileUpload
   */
  confirmInternalFileUpload: {
    methodKind: "unary";
    input: typeof ConfirmInternalFileUploadRequestSchema;
    output: typeof ConfirmFileUploadResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileCommandsService.RegenerateInternalUploadURL
   */
  regenerateInternalUploadURL: {
    methodKind: "unary";
    input: typeof RegenerateInternalUploadURLRequestSchema;
    output: typeof RegenerateInternalUploadURLResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_files_v1_file, 0);

/**
 * FileQueriesService handles file read operations
 *
 * @generated from service files.v1.FileQueriesService
 */
export const FileQueriesService: GenService<{
  /**
   * @generated from rpc files.v1.FileQueriesService.GetFile
   */
  getFile: {
    methodKind: "unary";
    input: typeof GetFileRequestSchema;
    output: typeof GetFileResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileQueriesService.ListFiles
   */
  listFiles: {
    methodKind: "unary";
    input: typeof ListFilesRequestSchema;
    output: typeof ListFilesResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileQueriesService.GenerateAccessURL
   */
  generateAccessURL: {
    methodKind: "unary";
    input: typeof GenerateAccessURLRequestSchema;
    output: typeof GenerateAccessURLResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileQueriesService.GetStorageQuota
   */
  getStorageQuota: {
    methodKind: "unary";
    input: typeof GetStorageQuotaRequestSchema;
    output: typeof GetStorageQuotaResponseSchema;
  },
  /**
   * @generated from rpc files.v1.FileQueriesService.ListFilesByEntities
   */
  listFilesByEntities: {
    methodKind: "unary";
    input: typeof ListFilesByEntitiesRequestSchema;
    output: typeof ListFilesByEntitiesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_files_v1_file, 1);

